import React from 'react'

import clsx from 'clsx'

import iconDescriptions from './constants'

import classes from './Icon.module.scss'

const HalfStar = props => {
  return (
    <span className={clsx('Icon__HalfStar', classes.base, classes.composed, 'icon-star-half')}>
      <Icon {...props} style={{ position: 'absolute', top: 0 }} icon={['fad', 'star-half-1']} />
      <Icon {...props} style={{ color: '#D8DADA', position: 'absolute', top: 0 }} icon={['fad', 'star-half-2']} />
    </span>
  )
}

const exceptions = {
  'fad-star-half': HalfStar,
}

const getIconDescription = iconName => {
  const cleanName = iconName.replace(/^(fas|fad|far|fab|fal|ga|ic)-/, '').replace(/-/g, ' ')

  // Return a functional description or generate a descriptive phrase
  const defaultDescription = `${cleanName.charAt(0).toUpperCase() + cleanName.slice(1)}`

  return iconDescriptions[cleanName] || defaultDescription
}

/** @type {import("./types").default} */
const Icon = ({ className, icon, prefix = 'fas', size = '16', ...props }) => {
  let currentIcon = icon

  if (prefix) currentIcon = `${prefix}-${icon}`

  if (Array.isArray(icon)) currentIcon = icon.join('-')

  const classNames = clsx(classes.base, classes.icon, { [classes[`size${size}`]]: size }, classes.root, className)

  if (exceptions[currentIcon]) {
    const Component = exceptions[currentIcon]
    return <Component className={clsx('Icon__Component', classes.svg, classNames)} />
  }

  return (
    <i
      data-testid={`icon-${currentIcon}`}
      data-icon={currentIcon}
      role="img"
      aria-label={getIconDescription(currentIcon)}
      className={clsx('Icon', `getapp-font-${currentIcon}`, classNames)}
      {...props}
    />
  )
}

export default Icon
